<template>
  <div class="tribe-summary">
    <p class="text-center m-b-5 f-w-600">
      {{ portfolioParameter.tribeName }}
    </p>
    <p class="text-center m-b-0">
      <span class="property-data">
        <i class="fa fa-fw fa-lg fa-globe"></i> {{ portfolioParameter.website }}
      </span>
      <span class="property-data">
        <i class="fa fa-fw fa-lg fa-envelope"></i> {{ portfolioParameter.email }}
      </span>
      <span class="property-data">
        <i class="fa fa-fw fa-lg fa-phone-volume"></i> {{ portfolioParameter.telephone }}
      </span>
      <span class="property-data">
        <i class="fa fa-fw fa-lg fa-map-marker-alt"></i> {{ portfolioParameter.address }} , {{ portfolioParameter.city }} , {{ portfolioParameter.state }} , {{ portfolioParameter.zip }}
      </span>
    </p>
  </div>
</template>

<script>
import { Tool } from '@/util/index'
const tool = new Tool()

export default {
  name: 'tribe-summary',
  data () {
    return {
      portfolioParameter: this.store.getters.getPortfolioJson
    }
  },
  watch: {
    'store.getters.getPortfolioJson': {
      handler: function (val) {
        this.initTribeSummary()
      }
    }
  },
  mounted () {
    if (tool.isNotEmpty(this.store.getters.getPortfolioJson)) {
      this.initTribeSummary()
    }
  },
  methods: {
    initTribeSummary () {
      this.portfolioParameter = this.store.getters.getPortfolioJson
    }
  }
}
</script>

<style scoped>
.tribe-summary {
  border-top: 1px solid #ddd;
  padding-top: 10px;
  font-size: 10px;
}
.tribe-summary .property-data {
  margin-right: 10px;
}
.tribe-summary .property-data:last-child {
  margin-right: 0;
}
</style>
